export default "/assets/images/column-image10.882b58746e209263.png";